import { Injectable } from '@angular/core';
import { CanActivate, Router, UrlTree } from '@angular/router';
import { Observable } from 'rxjs';

@Injectable({ providedIn: 'root' })
export class RootCanActivateService implements CanActivate {
  constructor(private router: Router) {}

  canActivate():
    | boolean
    | UrlTree
    | Observable<boolean | UrlTree>
    | Promise<boolean | UrlTree> {
    const parts = window.location.host.split('.');
    const secondPart = parts[1]?.split(':')[0]; // Strip port for localhost:XXXX
    if (
      (parts.length <= 2 || parts[0] === 'www') &&
      secondPart !== 'localhost'
    ) {
      return this.router.createUrlTree(['/public']);
    }
    return this.router.createUrlTree(['/production']);
  }
}
